/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createAccount = /* GraphQL */ `mutation CreateAccount(
  $input: CreateAccountInput!
  $condition: ModelAccountConditionInput
) {
  createAccount(input: $input, condition: $condition) {
    id
    gid
    name
    projects {
      nextToken
      __typename
    }
    fileuploads {
      originalName
      createdAt
      fileName
      fileStatus
      fileError
      numRecords
      numErrors
      totalRecords
      writtenRecords
      __typename
    }
    integrations {
      hubspot
      klaviyo
      __typename
    }
    defaultSchemaMappings {
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    aliasId
    fonts {
      fontFamily
      __typename
    }
    mediaGallery {
      url
      projectId
      type
      __typename
    }
    minisiteDomain
    mfaEnabled
    ownerId
    users {
      nextToken
      __typename
    }
    accountUsageType
    companySize
    tierId
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    featureOverrides {
      nextToken
      __typename
    }
    createNewVideosWithBlingLogo
    accountType {
      levelName
      __typename
    }
    currentBillingPeriod {
      startDate
      endDate
      __typename
    }
    ppvCurrentBillingPeriod {
      startDate
      endDate
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    branding
    defaultCrm
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountMutationVariables,
  APITypes.CreateAccountMutation
>;
export const updateAccount = /* GraphQL */ `mutation UpdateAccount(
  $input: UpdateAccountInput!
  $condition: ModelAccountConditionInput
) {
  updateAccount(input: $input, condition: $condition) {
    id
    gid
    name
    projects {
      nextToken
      __typename
    }
    fileuploads {
      originalName
      createdAt
      fileName
      fileStatus
      fileError
      numRecords
      numErrors
      totalRecords
      writtenRecords
      __typename
    }
    integrations {
      hubspot
      klaviyo
      __typename
    }
    defaultSchemaMappings {
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    aliasId
    fonts {
      fontFamily
      __typename
    }
    mediaGallery {
      url
      projectId
      type
      __typename
    }
    minisiteDomain
    mfaEnabled
    ownerId
    users {
      nextToken
      __typename
    }
    accountUsageType
    companySize
    tierId
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    featureOverrides {
      nextToken
      __typename
    }
    createNewVideosWithBlingLogo
    accountType {
      levelName
      __typename
    }
    currentBillingPeriod {
      startDate
      endDate
      __typename
    }
    ppvCurrentBillingPeriod {
      startDate
      endDate
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    branding
    defaultCrm
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountMutationVariables,
  APITypes.UpdateAccountMutation
>;
export const deleteAccount = /* GraphQL */ `mutation DeleteAccount(
  $input: DeleteAccountInput!
  $condition: ModelAccountConditionInput
) {
  deleteAccount(input: $input, condition: $condition) {
    id
    gid
    name
    projects {
      nextToken
      __typename
    }
    fileuploads {
      originalName
      createdAt
      fileName
      fileStatus
      fileError
      numRecords
      numErrors
      totalRecords
      writtenRecords
      __typename
    }
    integrations {
      hubspot
      klaviyo
      __typename
    }
    defaultSchemaMappings {
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    aliasId
    fonts {
      fontFamily
      __typename
    }
    mediaGallery {
      url
      projectId
      type
      __typename
    }
    minisiteDomain
    mfaEnabled
    ownerId
    users {
      nextToken
      __typename
    }
    accountUsageType
    companySize
    tierId
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    featureOverrides {
      nextToken
      __typename
    }
    createNewVideosWithBlingLogo
    accountType {
      levelName
      __typename
    }
    currentBillingPeriod {
      startDate
      endDate
      __typename
    }
    ppvCurrentBillingPeriod {
      startDate
      endDate
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    branding
    defaultCrm
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountMutationVariables,
  APITypes.DeleteAccountMutation
>;
export const createInvite = /* GraphQL */ `mutation CreateInvite(
  $input: CreateInviteInput!
  $condition: ModelInviteConditionInput
) {
  createInvite(input: $input, condition: $condition) {
    id
    senderId
    email
    accountId
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    confirmCode
    confirmed
    createdAt
    updatedAt
    permissions
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInviteMutationVariables,
  APITypes.CreateInviteMutation
>;
export const updateInvite = /* GraphQL */ `mutation UpdateInvite(
  $input: UpdateInviteInput!
  $condition: ModelInviteConditionInput
) {
  updateInvite(input: $input, condition: $condition) {
    id
    senderId
    email
    accountId
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    confirmCode
    confirmed
    createdAt
    updatedAt
    permissions
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInviteMutationVariables,
  APITypes.UpdateInviteMutation
>;
export const deleteInvite = /* GraphQL */ `mutation DeleteInvite(
  $input: DeleteInviteInput!
  $condition: ModelInviteConditionInput
) {
  deleteInvite(input: $input, condition: $condition) {
    id
    senderId
    email
    accountId
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    confirmCode
    confirmed
    createdAt
    updatedAt
    permissions
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInviteMutationVariables,
  APITypes.DeleteInviteMutation
>;
export const createTier = /* GraphQL */ `mutation CreateTier(
  $input: CreateTierInput!
  $condition: ModelTierConditionInput
) {
  createTier(input: $input, condition: $condition) {
    id
    name
    monthlyPrice
    annualPrice
    description
    enabled
    features {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTierMutationVariables,
  APITypes.CreateTierMutation
>;
export const updateTier = /* GraphQL */ `mutation UpdateTier(
  $input: UpdateTierInput!
  $condition: ModelTierConditionInput
) {
  updateTier(input: $input, condition: $condition) {
    id
    name
    monthlyPrice
    annualPrice
    description
    enabled
    features {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTierMutationVariables,
  APITypes.UpdateTierMutation
>;
export const deleteTier = /* GraphQL */ `mutation DeleteTier(
  $input: DeleteTierInput!
  $condition: ModelTierConditionInput
) {
  deleteTier(input: $input, condition: $condition) {
    id
    name
    monthlyPrice
    annualPrice
    description
    enabled
    features {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTierMutationVariables,
  APITypes.DeleteTierMutation
>;
export const createFeature = /* GraphQL */ `mutation CreateFeature(
  $input: CreateFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  createFeature(input: $input, condition: $condition) {
    id
    name
    description
    enabled
    tierFeatures {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFeatureMutationVariables,
  APITypes.CreateFeatureMutation
>;
export const updateFeature = /* GraphQL */ `mutation UpdateFeature(
  $input: UpdateFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  updateFeature(input: $input, condition: $condition) {
    id
    name
    description
    enabled
    tierFeatures {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFeatureMutationVariables,
  APITypes.UpdateFeatureMutation
>;
export const deleteFeature = /* GraphQL */ `mutation DeleteFeature(
  $input: DeleteFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  deleteFeature(input: $input, condition: $condition) {
    id
    name
    description
    enabled
    tierFeatures {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFeatureMutationVariables,
  APITypes.DeleteFeatureMutation
>;
export const createTierFeature = /* GraphQL */ `mutation CreateTierFeature(
  $input: CreateTierFeatureInput!
  $condition: ModelTierFeatureConditionInput
) {
  createTierFeature(input: $input, condition: $condition) {
    id
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    tierId
    feature {
      id
      name
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    featureId
    description
    limitValue
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTierFeatureMutationVariables,
  APITypes.CreateTierFeatureMutation
>;
export const updateTierFeature = /* GraphQL */ `mutation UpdateTierFeature(
  $input: UpdateTierFeatureInput!
  $condition: ModelTierFeatureConditionInput
) {
  updateTierFeature(input: $input, condition: $condition) {
    id
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    tierId
    feature {
      id
      name
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    featureId
    description
    limitValue
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTierFeatureMutationVariables,
  APITypes.UpdateTierFeatureMutation
>;
export const deleteTierFeature = /* GraphQL */ `mutation DeleteTierFeature(
  $input: DeleteTierFeatureInput!
  $condition: ModelTierFeatureConditionInput
) {
  deleteTierFeature(input: $input, condition: $condition) {
    id
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    tierId
    feature {
      id
      name
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    featureId
    description
    limitValue
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTierFeatureMutationVariables,
  APITypes.DeleteTierFeatureMutation
>;
export const createAccountFeatureOverride = /* GraphQL */ `mutation CreateAccountFeatureOverride(
  $input: CreateAccountFeatureOverrideInput!
  $condition: ModelAccountFeatureOverrideConditionInput
) {
  createAccountFeatureOverride(input: $input, condition: $condition) {
    id
    accountId
    featureId
    reason
    limitValue
    enabled
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountFeatureOverrideMutationVariables,
  APITypes.CreateAccountFeatureOverrideMutation
>;
export const updateAccountFeatureOverride = /* GraphQL */ `mutation UpdateAccountFeatureOverride(
  $input: UpdateAccountFeatureOverrideInput!
  $condition: ModelAccountFeatureOverrideConditionInput
) {
  updateAccountFeatureOverride(input: $input, condition: $condition) {
    id
    accountId
    featureId
    reason
    limitValue
    enabled
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountFeatureOverrideMutationVariables,
  APITypes.UpdateAccountFeatureOverrideMutation
>;
export const deleteAccountFeatureOverride = /* GraphQL */ `mutation DeleteAccountFeatureOverride(
  $input: DeleteAccountFeatureOverrideInput!
  $condition: ModelAccountFeatureOverrideConditionInput
) {
  deleteAccountFeatureOverride(input: $input, condition: $condition) {
    id
    accountId
    featureId
    reason
    limitValue
    enabled
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountFeatureOverrideMutationVariables,
  APITypes.DeleteAccountFeatureOverrideMutation
>;
export const createFormData = /* GraphQL */ `mutation CreateFormData(
  $input: CreateFormDataInput!
  $condition: ModelFormDataConditionInput
) {
  createFormData(input: $input, condition: $condition) {
    id
    accountOwner
    projectFormDataId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    data
    sessionId
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormDataMutationVariables,
  APITypes.CreateFormDataMutation
>;
export const updateFormData = /* GraphQL */ `mutation UpdateFormData(
  $input: UpdateFormDataInput!
  $condition: ModelFormDataConditionInput
) {
  updateFormData(input: $input, condition: $condition) {
    id
    accountOwner
    projectFormDataId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    data
    sessionId
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFormDataMutationVariables,
  APITypes.UpdateFormDataMutation
>;
export const deleteFormData = /* GraphQL */ `mutation DeleteFormData(
  $input: DeleteFormDataInput!
  $condition: ModelFormDataConditionInput
) {
  deleteFormData(input: $input, condition: $condition) {
    id
    accountOwner
    projectFormDataId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    data
    sessionId
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFormDataMutationVariables,
  APITypes.DeleteFormDataMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const deleteProject = /* GraphQL */ `mutation DeleteProject(
  $input: DeleteProjectInput!
  $condition: ModelProjectConditionInput
) {
  deleteProject(input: $input, condition: $condition) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    customLoaderAssets {
      spinnerUrl
      diamondUrl
      loaderUrl
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    formData {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    renders {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    availableSceneLibraries {
      nextToken
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    crmTokens {
      selectedCrm
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectMutationVariables,
  APITypes.DeleteProjectMutation
>;
export const createProjectVersion = /* GraphQL */ `mutation CreateProjectVersion(
  $input: CreateProjectVersionInput!
  $condition: ModelProjectVersionConditionInput
) {
  createProjectVersion(input: $input, condition: $condition) {
    id
    accountOwner
    owner
    stateJsonSchemaStr
    settingsJsonSchemaStr
    settings
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    updatedAt
    playerVersionToUse
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    textToVideoScript
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    createdAt
    projectProjectVersionsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectVersionMutationVariables,
  APITypes.CreateProjectVersionMutation
>;
export const deleteProjectVersion = /* GraphQL */ `mutation DeleteProjectVersion(
  $input: DeleteProjectVersionInput!
  $condition: ModelProjectVersionConditionInput
) {
  deleteProjectVersion(input: $input, condition: $condition) {
    id
    accountOwner
    owner
    stateJsonSchemaStr
    settingsJsonSchemaStr
    settings
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    updatedAt
    playerVersionToUse
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    textToVideoScript
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    createdAt
    projectProjectVersionsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectVersionMutationVariables,
  APITypes.DeleteProjectVersionMutation
>;
export const createSceneLibrary = /* GraphQL */ `mutation CreateSceneLibrary(
  $input: CreateSceneLibraryInput!
  $condition: ModelSceneLibraryConditionInput
) {
  createSceneLibrary(input: $input, condition: $condition) {
    id
    title
    vibe
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    description
    thumbnail
    accounts {
      nextToken
      __typename
    }
    useCases {
      nextToken
      __typename
    }
    projects {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSceneLibraryMutationVariables,
  APITypes.CreateSceneLibraryMutation
>;
export const updateSceneLibrary = /* GraphQL */ `mutation UpdateSceneLibrary(
  $input: UpdateSceneLibraryInput!
  $condition: ModelSceneLibraryConditionInput
) {
  updateSceneLibrary(input: $input, condition: $condition) {
    id
    title
    vibe
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    description
    thumbnail
    accounts {
      nextToken
      __typename
    }
    useCases {
      nextToken
      __typename
    }
    projects {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSceneLibraryMutationVariables,
  APITypes.UpdateSceneLibraryMutation
>;
export const deleteSceneLibrary = /* GraphQL */ `mutation DeleteSceneLibrary(
  $input: DeleteSceneLibraryInput!
  $condition: ModelSceneLibraryConditionInput
) {
  deleteSceneLibrary(input: $input, condition: $condition) {
    id
    title
    vibe
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    description
    thumbnail
    accounts {
      nextToken
      __typename
    }
    useCases {
      nextToken
      __typename
    }
    projects {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSceneLibraryMutationVariables,
  APITypes.DeleteSceneLibraryMutation
>;
export const createServerRender = /* GraphQL */ `mutation CreateServerRender(
  $input: CreateServerRenderInput!
  $condition: ModelServerRenderConditionInput
) {
  createServerRender(input: $input, condition: $condition) {
    id
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    scenes
    data
    env
    outputFileName
    quality
    frameToStart
    frameToEnd
    format
    status {
      ready
      status
      downloadLink
      code
      __typename
    }
    cognitoUserIdentifier
    cognitoGroupOwner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateServerRenderMutationVariables,
  APITypes.CreateServerRenderMutation
>;
export const updateServerRender = /* GraphQL */ `mutation UpdateServerRender(
  $input: UpdateServerRenderInput!
  $condition: ModelServerRenderConditionInput
) {
  updateServerRender(input: $input, condition: $condition) {
    id
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    scenes
    data
    env
    outputFileName
    quality
    frameToStart
    frameToEnd
    format
    status {
      ready
      status
      downloadLink
      code
      __typename
    }
    cognitoUserIdentifier
    cognitoGroupOwner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServerRenderMutationVariables,
  APITypes.UpdateServerRenderMutation
>;
export const deleteServerRender = /* GraphQL */ `mutation DeleteServerRender(
  $input: DeleteServerRenderInput!
  $condition: ModelServerRenderConditionInput
) {
  deleteServerRender(input: $input, condition: $condition) {
    id
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    scenes
    data
    env
    outputFileName
    quality
    frameToStart
    frameToEnd
    format
    status {
      ready
      status
      downloadLink
      code
      __typename
    }
    cognitoUserIdentifier
    cognitoGroupOwner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteServerRenderMutationVariables,
  APITypes.DeleteServerRenderMutation
>;
export const createUseCase = /* GraphQL */ `mutation CreateUseCase(
  $input: CreateUseCaseInput!
  $condition: ModelUseCaseConditionInput
) {
  createUseCase(input: $input, condition: $condition) {
    id
    name
    projectId
    images
    shortDescription
    longDescription
    thumbnail
    demoLink
    videoPreview
    lineupId
    lineupsIds
    scenes
    liveControl
    liveControlSchema
    dynamicDataSchema
    categoryId
    category {
      id
      name
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUseCaseMutationVariables,
  APITypes.CreateUseCaseMutation
>;
export const updateUseCase = /* GraphQL */ `mutation UpdateUseCase(
  $input: UpdateUseCaseInput!
  $condition: ModelUseCaseConditionInput
) {
  updateUseCase(input: $input, condition: $condition) {
    id
    name
    projectId
    images
    shortDescription
    longDescription
    thumbnail
    demoLink
    videoPreview
    lineupId
    lineupsIds
    scenes
    liveControl
    liveControlSchema
    dynamicDataSchema
    categoryId
    category {
      id
      name
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUseCaseMutationVariables,
  APITypes.UpdateUseCaseMutation
>;
export const deleteUseCase = /* GraphQL */ `mutation DeleteUseCase(
  $input: DeleteUseCaseInput!
  $condition: ModelUseCaseConditionInput
) {
  deleteUseCase(input: $input, condition: $condition) {
    id
    name
    projectId
    images
    shortDescription
    longDescription
    thumbnail
    demoLink
    videoPreview
    lineupId
    lineupsIds
    scenes
    liveControl
    liveControlSchema
    dynamicDataSchema
    categoryId
    category {
      id
      name
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUseCaseMutationVariables,
  APITypes.DeleteUseCaseMutation
>;
export const createUseCaseTag = /* GraphQL */ `mutation CreateUseCaseTag(
  $input: CreateUseCaseTagInput!
  $condition: ModelUseCaseTagConditionInput
) {
  createUseCaseTag(input: $input, condition: $condition) {
    tag
    useCaseIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUseCaseTagMutationVariables,
  APITypes.CreateUseCaseTagMutation
>;
export const updateUseCaseTag = /* GraphQL */ `mutation UpdateUseCaseTag(
  $input: UpdateUseCaseTagInput!
  $condition: ModelUseCaseTagConditionInput
) {
  updateUseCaseTag(input: $input, condition: $condition) {
    tag
    useCaseIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUseCaseTagMutationVariables,
  APITypes.UpdateUseCaseTagMutation
>;
export const deleteUseCaseTag = /* GraphQL */ `mutation DeleteUseCaseTag(
  $input: DeleteUseCaseTagInput!
  $condition: ModelUseCaseTagConditionInput
) {
  deleteUseCaseTag(input: $input, condition: $condition) {
    tag
    useCaseIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUseCaseTagMutationVariables,
  APITypes.DeleteUseCaseTagMutation
>;
export const createUseCaseCategory = /* GraphQL */ `mutation CreateUseCaseCategory(
  $input: CreateUseCaseCategoryInput!
  $condition: ModelUseCaseCategoryConditionInput
) {
  createUseCaseCategory(input: $input, condition: $condition) {
    id
    name
    description
    thumbnail
    useCases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUseCaseCategoryMutationVariables,
  APITypes.CreateUseCaseCategoryMutation
>;
export const updateUseCaseCategory = /* GraphQL */ `mutation UpdateUseCaseCategory(
  $input: UpdateUseCaseCategoryInput!
  $condition: ModelUseCaseCategoryConditionInput
) {
  updateUseCaseCategory(input: $input, condition: $condition) {
    id
    name
    description
    thumbnail
    useCases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUseCaseCategoryMutationVariables,
  APITypes.UpdateUseCaseCategoryMutation
>;
export const deleteUseCaseCategory = /* GraphQL */ `mutation DeleteUseCaseCategory(
  $input: DeleteUseCaseCategoryInput!
  $condition: ModelUseCaseCategoryConditionInput
) {
  deleteUseCaseCategory(input: $input, condition: $condition) {
    id
    name
    description
    thumbnail
    useCases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUseCaseCategoryMutationVariables,
  APITypes.DeleteUseCaseCategoryMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    email
    name
    lastName
    picture
    accounts {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    email
    name
    lastName
    picture
    accounts {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    email
    name
    lastName
    picture
    accounts {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createAccountSceneLibraries = /* GraphQL */ `mutation CreateAccountSceneLibraries(
  $input: CreateAccountSceneLibrariesInput!
  $condition: ModelAccountSceneLibrariesConditionInput
) {
  createAccountSceneLibraries(input: $input, condition: $condition) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountSceneLibrariesMutationVariables,
  APITypes.CreateAccountSceneLibrariesMutation
>;
export const updateAccountSceneLibraries = /* GraphQL */ `mutation UpdateAccountSceneLibraries(
  $input: UpdateAccountSceneLibrariesInput!
  $condition: ModelAccountSceneLibrariesConditionInput
) {
  updateAccountSceneLibraries(input: $input, condition: $condition) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountSceneLibrariesMutationVariables,
  APITypes.UpdateAccountSceneLibrariesMutation
>;
export const deleteAccountSceneLibraries = /* GraphQL */ `mutation DeleteAccountSceneLibraries(
  $input: DeleteAccountSceneLibrariesInput!
  $condition: ModelAccountSceneLibrariesConditionInput
) {
  deleteAccountSceneLibraries(input: $input, condition: $condition) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountSceneLibrariesMutationVariables,
  APITypes.DeleteAccountSceneLibrariesMutation
>;
export const createProjectSceneLibraries = /* GraphQL */ `mutation CreateProjectSceneLibraries(
  $input: CreateProjectSceneLibrariesInput!
  $condition: ModelProjectSceneLibrariesConditionInput
) {
  createProjectSceneLibraries(input: $input, condition: $condition) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectSceneLibrariesMutationVariables,
  APITypes.CreateProjectSceneLibrariesMutation
>;
export const updateProjectSceneLibraries = /* GraphQL */ `mutation UpdateProjectSceneLibraries(
  $input: UpdateProjectSceneLibrariesInput!
  $condition: ModelProjectSceneLibrariesConditionInput
) {
  updateProjectSceneLibraries(input: $input, condition: $condition) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectSceneLibrariesMutationVariables,
  APITypes.UpdateProjectSceneLibrariesMutation
>;
export const deleteProjectSceneLibraries = /* GraphQL */ `mutation DeleteProjectSceneLibraries(
  $input: DeleteProjectSceneLibrariesInput!
  $condition: ModelProjectSceneLibrariesConditionInput
) {
  deleteProjectSceneLibraries(input: $input, condition: $condition) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectSceneLibrariesMutationVariables,
  APITypes.DeleteProjectSceneLibrariesMutation
>;
export const createUseCaseSceneLibraries = /* GraphQL */ `mutation CreateUseCaseSceneLibraries(
  $input: CreateUseCaseSceneLibrariesInput!
  $condition: ModelUseCaseSceneLibrariesConditionInput
) {
  createUseCaseSceneLibraries(input: $input, condition: $condition) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUseCaseSceneLibrariesMutationVariables,
  APITypes.CreateUseCaseSceneLibrariesMutation
>;
export const updateUseCaseSceneLibraries = /* GraphQL */ `mutation UpdateUseCaseSceneLibraries(
  $input: UpdateUseCaseSceneLibrariesInput!
  $condition: ModelUseCaseSceneLibrariesConditionInput
) {
  updateUseCaseSceneLibraries(input: $input, condition: $condition) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUseCaseSceneLibrariesMutationVariables,
  APITypes.UpdateUseCaseSceneLibrariesMutation
>;
export const deleteUseCaseSceneLibraries = /* GraphQL */ `mutation DeleteUseCaseSceneLibraries(
  $input: DeleteUseCaseSceneLibrariesInput!
  $condition: ModelUseCaseSceneLibrariesConditionInput
) {
  deleteUseCaseSceneLibraries(input: $input, condition: $condition) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUseCaseSceneLibrariesMutationVariables,
  APITypes.DeleteUseCaseSceneLibrariesMutation
>;
export const createProject = /* GraphQL */ `mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    customLoaderAssets {
      spinnerUrl
      diamondUrl
      loaderUrl
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    formData {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    renders {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    availableSceneLibraries {
      nextToken
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    crmTokens {
      selectedCrm
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectMutationVariables,
  APITypes.CreateProjectMutation
>;
export const updateProject = /* GraphQL */ `mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    customLoaderAssets {
      spinnerUrl
      diamondUrl
      loaderUrl
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    formData {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    renders {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    availableSceneLibraries {
      nextToken
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    crmTokens {
      selectedCrm
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectMutationVariables,
  APITypes.UpdateProjectMutation
>;
export const updateProjectVersion = /* GraphQL */ `mutation UpdateProjectVersion($input: UpdateProjectVersionInput!) {
  updateProjectVersion(input: $input) {
    id
    accountOwner
    owner
    stateJsonSchemaStr
    settingsJsonSchemaStr
    settings
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    updatedAt
    playerVersionToUse
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    textToVideoScript
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    createdAt
    projectProjectVersionsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectVersionMutationVariables,
  APITypes.UpdateProjectVersionMutation
>;
export const sendInstantNotification = /* GraphQL */ `mutation SendInstantNotification($input: SendInstantNotificationInput) {
  sendInstantNotification(input: $input) {
    type
    subType
    status
    title
    message
    owner
    projectId
    extra
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendInstantNotificationMutationVariables,
  APITypes.SendInstantNotificationMutation
>;
